import policyAndGeneralTerms from "../repositories/policyAndGeneralTerms";

export default {
  getPolicy: async (
    type: string,
    callback: (data?: any, err?: any) => void
  ) => {
    try {
      const rs = await policyAndGeneralTerms.getPolicy(type);
      callback(rs, null);
    } catch (error) {
      callback(null, error);
    }
  },
};
